var render = function render(){var _vm=this,_c=_vm._self._c;return _c('extraction-saisie',{attrs:{"title":_vm.title,"file-name":_vm.fileName}})
}
var staticRenderFns = []

export { render, staticRenderFns }